import { z } from "zod"

export const GROUPINGS = [
  "status",
  "calibration",
  "category",
  "facility",
  "classification",
  "ownership",
] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const groupChoiceSchema = z.enum([...GROUPINGS, "none"])

export const GROUPING_LABELS: Record<Grouping, string> = {
  status: "Status",
  calibration: "Calibration",
  category: "Category",
  facility: "Facility",
  classification: "Class",
  ownership: "Ownership",
}
